<template>
	<v-container>
		<v-row>
			<v-col cols="12" sm="8">
				<h2 class="mw-h1">We're looking forward to hearing from you</h2>
				<ContactForm :id="formId" :questions="questions"></ContactForm>
			</v-col>
			<v-col cols="12" sm="4" class="pl-5">
				<div class="text-large mt-12 mb-3 pa-2">
					<p>Meister.works ltd<br/>
					11-12 St James's Square, <br/>
					London SW1Y 4LB, <br/>
					Phone +44 (0) 203 086 7868, <br/>
					Email <a href="mailto:talk@m.works">talk@m.works</a></p>
				</div>
				<v-card>
					<v-card-title color="green" class="text-large">Looking for our mailing list?</v-card-title>
					<v-card-text>Meisterworks don't maintain a mailing list for general research purposes; this is how we ensure that we invite individuals to research that is directly relevant to them, rather than contributing to the internet-wide epidemic of unwanted messages. Please feel free to use the details above to get in touch with us instead</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
	import ContactForm from "../components/tools/ContactForm.vue"
	export default {
		name: "Contact",
		components:{
			ContactForm: ContactForm
		}, 
		data: () => {
			return {
				formId: "MainContactForm",
				questions: [
					{ value: 'name', label: "Name", type: 'text-field'},
					{ value: 'email', label: "Email", type: 'text-field'},
					{ value: 'message', label: "Your Message", type: 'textarea'}
				]
			}
		}
	}
</script>